
import type { PropType } from 'vue'
import { BaseIdTogglePanel, BaseIdTogglePanelButton, CollapseHeight } from '@empathyco/x-components'
import { defineComponent, ref } from 'vue'

let uidCounter = 0
export default defineComponent({
  name: 'XTogglePanel',
  components: {
    BaseIdTogglePanel,
    BaseIdTogglePanelButton,
  },
  props: {
    startOpen: {
      type: Boolean,
    },
    iconPosition: {
      type: String as PropType<'left' | 'right'>,
      default: 'left',
    },
    iconSize: {
      type: String as PropType<'normal' | 'big'>,
      default: 'normal',
    },
    disabled: {
      type: Boolean,
    },
  },
  setup(props) {
    const uid = `x-toggle-panel-${uidCounter}`
    uidCounter++

    const baseClass = 'epb-x-toggle-panel'

    const animation = CollapseHeight

    const isPanelOpen = ref(props.startOpen)

    const togglePanel = () => {
      isPanelOpen.value = !isPanelOpen.value
    }

    return {
      uid,
      baseClass,
      animation,
      isPanelOpen,
      togglePanel,
    }
  },
})
